<template>
  <div
    class="share-mask-layer"
    v-show="MASK_ACTIVE"
    @click.self="closeMask"
    @mousewheel.stop.prevent
  >
    <div class="share-container">
      <div class="share_link">
        <div class="share_link_close">
          <p>SHARE</p>
          <img src="@/assets/images/login/close.png" @click="closeMask" />
        </div>
        <div class="share_link_logo">
          <div class="share_link_tw share_link_logos" @click="shareSns('tw', ID)">
            <img src="@/assets/images/login/x-icon.png" />
          </div>
          <div class="share_link_fb share_link_logos" @click="shareSns('fb', ID)">
            <img src="@/assets/images/login/fb_icon.png" />
          </div>
        </div>
        <div class="share_link_copy">
          <p>{{ worksUrl }}</p>
          <button class="copy" ref="copyButton" :data-clipboard-text="worksUrl">
            COPY
          </button>
        </div>
      </div>
      <div class="annotation"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Clipboard from 'clipboard'

export default {
  name: 'ShareMask',

  components: {},
  data: () => ({}),
  created() {},

  mounted() {
    this.initClipboard()
  },
  watch: {},
  computed: {
    ...mapState({
      MASK_ACTIVE: state => state.ShareMask.MASK_ACTIVE,

      ID: state => state.ShareMask.ID,
    }),
    worksUrl() {
      return `${location.origin}/contest/watch?worksId=${this.ID}`
    },
  },
  methods: {
    closeMask() {
      this.$store.commit('ShareMask/SET_MASK_ACTIVE', false)
    },
    shareSns(channel, id) {
      this.$utils.snsShare(channel, id)
      // this.daqShare(channel, id);

      // todo
      this.axios.post('/analytics/works-share', {
        worksId: String(id),
        channel,
      })
    },
    // daqShare(channel, id) {
    //   // todo
    //   this.$store.dispatch("Config/daq", {
    //     eventName: "works_share",
    //     data1: id,
    //     data2: channel,
    //   });
    // },
    // 初始化复制插件
    initClipboard() {
      const clipboard = new Clipboard(this.$refs.copyButton)
      clipboard.on('success', e => {
        console.log('copy success')
        alert('copied')
      })
      clipboard.on('error', e => {
        console.log('copy failed')
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.share-mask-layer {
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;

  .share-container {
    .share_link {
      box-sizing: border-box;
      // padding: pxTorem(18px) pxTorem(15px) pxTorem(60px);
      position: absolute;
      width: pxTorem(476px);
      aspect-ratio: 490/287;
      top: 10%;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      background: #000 url('../assets/images/share/share-bg.png') no-repeat;
      background-size: cover;
      .share_link_close {
        display: flex;
        justify-content: space-between;
        position: relative;
        p {
          padding: pxTorem(10px) 0;
          color: #2f6a8c;
          font-weight: 900;
          text-align: center;
          width: 100%;

          font-family: 'ge';
          font-size: pxTorem(28px);
          color: white;
          -webkit-text-stroke: pxTorem(3px) #5a3010;
          paint-order: stroke fill;
          text-shadow: 0px 2px 0px #775f3d;
          margin-top: 0.7rem;
        }
        img {
          position: absolute;
          right: 1rem;
          top: 0.5rem;
          cursor: pointer;
          width: pxTorem(36px);
          height: pxTorem(36px);
          display: block;
        }
      }
      .share_link_logo {
        text-align: center;
        box-sizing: border-box;
        display: flex;
        margin-top: pxTorem(0px);
        justify-content: center;
        .share_link_logos {
          cursor: pointer;
          &:first-child {
            transform: scale(1);
            margin-right: pxTorem(80px);
          }
          img {
            width: pxTorem(62px);
            height: pxTorem(62px);
          }
          p {
            color: black;
            font-size: pxTorem(18px);
            font-weight: 700;
            margin-top: pxTorem(9px);
          }
        }
      }
      .share_link_copy {
        box-sizing: border-box;
        margin-top: pxTorem(30px);
        color: #808080;
        font-size: pxTorem(18px);
        // margin-left: pxTorem(28px);
        box-sizing: border-box;
        padding: 0 pxTorem(10px);
        padding-right: 0;
        display: flex;
        justify-content: space-between;
        height: 37px;
        width: pxTorem(361px);
        margin-left: pxTorem(47px);
        overflow: hidden;
        line-height: pxTorem(40px);
        background: white;
        border-radius: 1rem;
        border: 2px solid #aa8565;
        outline: 2px solid #f4cdc4;

        p {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          height: 100%;
          line-height: 37px;
        }
        .copy {
          color: white;
          background: #2f6a8c;
          font-family: 'ge';
          font-weight: bold;
          font-size: pxTorem(20px);
          cursor: pointer;
          width: pxTorem(150px);
          background: #aa8565;
          border-radius: 1rem;
        }
      }
    }
    .annotation {
      font-size: pxTorem(18px);
      width: pxTorem(1000px);
      position: absolute;
      top: 76%;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
}
</style>
